module.exports = __webpack_public_path__ + "static/media/stefanvandenberg.05f13476.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/stefanvandenberg.webp
// module id = 492
// module chunks = 0